<template lang="pug">
  div.loader
    div
    div
    div
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
  .loader{
    color: #999;
    display: flex;
    align-items: center;
    justify-content: center;
    div{
      width: 12px;
      height: 12px;
      border-radius: 100%;
      margin: 2px;
      background-color: #3989cb;
      @-webkit-keyframes scale {
        0% {
          -webkit-transform: scale(1);
          transform: scale(1);
          opacity: 1; }
        45% {
          -webkit-transform: scale(0.1);
          transform: scale(0.1);
          opacity: 0.7; }
        80% {
          -webkit-transform: scale(1);
          transform: scale(1);
          opacity: 1; } }
      @keyframes scale {
        0% {
          -webkit-transform: scale(1);
          transform: scale(1);
          opacity: 1; }
        45% {
          -webkit-transform: scale(0.1);
          transform: scale(0.1);
          opacity: 0.7; }
        80% {
          -webkit-transform: scale(1);
          transform: scale(1);
          opacity: 1; } }

      &:nth-of-type(1){
        animation: scale 1s -.24s infinite;
      }
      &:nth-of-type(2){
        animation: scale 1s -.12s infinite;
      }
      &:nth-of-type(3){
        animation: scale 1s 0s infinite;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Loader.vue